import { ojs, app } from "modular-openscriptjs";

const h = app("h");

export default function SolidIcon(icon, ...args) {
	return h.$(h.i({ class: `fas fa-${icon}` }, ...args));
}
